
function cropImageDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/crop-image/crop-image-dialog.html?$$REVISION$$'
  }
}
export { cropImageDialog }
